import { render, staticRenderFns } from "./source.vue?vue&type=template&id=b90e34fc&scoped=true&"
import script from "./source.vue?vue&type=script&lang=js&"
export * from "./source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90e34fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b90e34fc')) {
      api.createRecord('b90e34fc', component.options)
    } else {
      api.reload('b90e34fc', component.options)
    }
    module.hot.accept("./source.vue?vue&type=template&id=b90e34fc&scoped=true&", function () {
      api.rerender('b90e34fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/dashboard/addon/source.vue"
export default component.exports